/* eslint-disable react/prop-types */
import React from 'react';
import {
  Button, Typography, Checkbox, FormControlLabel, Icon,
} from '@material-ui/core';
import { InlineDatePicker, InlineTimePicker } from 'material-ui-pickers';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';

const styles = {
  mainContainer: {
    paddingLeft: '12px',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '600px',
    margin: '10px 0',
  },
  button: {
    width: '200px',
    height: '40px',
    borderRadius: '0',
    backgroundColor: '#e0592a',
    color: '#ffffff',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '10px 0',
  },
  checkBoxColor: {
    color: '#000',
    padding: '0 5px',
  },
  addHourLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    margin: '10px 0',
    color: '#e0592a',
  },
  timeTextField: {
    width: '100px',
  },
  calendarInput: {
    border: '1px solid',
    borderRadius: '5px',
    width: '125px',
    padding: '5px',
    minWidth: '125px',
  },
  dashInbetween: {
    padding: '5px 10px',
  },
  timePickerWidth: {
    width: '70px',
    minWidth: '70px',
  },
  checkboxContainer: {
    margin: '10px 0',
  },
  timePickerSet: {
    display: 'flex',
    padding: '2px',
  },
  timePickerSetError: {
    display: 'flex',
    border: '1px solid red',
    padding: '2px',
    borderRadius: '5px',
  },
  errorText: {
    color: 'red',
  },
  timePickerContainer: {
    marginTop: '5px',
  },
  deleteCheckboxContainer: {
    width: '30px',
  },
  trashCanIcon: {
    fontSize: '24px',
    margin: '17% 0 0 30%',
  },
};

const HolidayHoursRow = ({
  date,
  hours,
  onChangeHolidayHour,
  onAddHolidayHour,
  onDeleteHolidayHour,
}) => {
  const ids = hours.map(hour => hour.id);
  const businessOpenAllDay = hours[0].businessOpenAllDay;
  const isAnyClose = hours.filter(hour => hour.isClose
    || (hour.open === null && hour.close === null)).length > 0;

  return (
    <div style={styles.rowContainer}>
      <InlineDatePicker
        value={moment.unix(date)}
        views={['year', 'month', 'day']}
        onChange={momentObj => onChangeHolidayHour(ids, 'date', momentObj.set('hour', 12).set('minute', 0).unix())}
        format="DD-MMM-YYYY"
        InputProps={{
          startAdornment: (<Icon>date_range</Icon>),
          disableUnderline: true,
        }}
        style={styles.calendarInput}
      />
      <FormControlLabel
        control={(
          <Checkbox
            checked={isAnyClose || false}
            onChange={() => onChangeHolidayHour(ids, 'isClose', !isAnyClose)}
            style={styles.checkBoxColor}
          />
        )}
        label="Closed"
        style={styles.checkboxContainer}
      />
      <div style={styles.timePickerContainer}>
        {
          hours.sort((a, b) => moment(a.open, 'HH:mm') - moment(b.open, 'HH:mm')).map((hour) => {
            const {
              id, open, close, isClose, isError,
            } = hour;
            return (
              <div style={isError ? styles.timePickerSetError : styles.timePickerSet}>
                <InlineTimePicker
                  style={styles.timePickerWidth}
                  value={moment(isClose ? null : open, 'HH:mm')}
                  onChange={momentObj => onChangeHolidayHour([id], 'open', momentObj.format('HH:mm'))}
                  InputProps={{ disableUnderline: true }}
                  invalidLabel="Close"
                />
                <div style={styles.dashInbetween}> - </div>
                <InlineTimePicker
                  style={styles.timePickerWidth}
                  value={moment(isClose ? null : close, 'HH:mm')}
                  onChange={momentObj => onChangeHolidayHour([id], 'close', momentObj.format('HH:mm'))}
                  InputProps={{ disableUnderline: true }}
                  invalidLabel="Close"
                />
                <div style={styles.deleteCheckboxContainer}>
                  <DeleteIcon
                    onClick={() => onDeleteHolidayHour([id])}
                    style={styles.trashCanIcon}
                  />
                </div>
              </div>
            );
          })
        }
      </div>
      <FormControlLabel
        control={(
          <Checkbox
            checked={businessOpenAllDay}
            onChange={() => onChangeHolidayHour(ids, 'businessOpenAllDay', !businessOpenAllDay)}
            style={styles.checkBoxColor}
          />
        )}
        label="24 Hours"
        style={styles.checkboxContainer}
      />
      <Typography
        style={styles.addHourLink}
        onClick={() => onAddHolidayHour(date, businessOpenAllDay)}
      >
        add hour
      </Typography>
    </div>
  );
};

const HolidayHours = ({
  data,
  onAddHolidayHour,
  onChangeHolidayHour,
  onDeleteHolidayHour,
}) => {
  let holidayMap = {};
  let errorMessage;
  data && data.map((holiday) => {
    const curr = holidayMap[holiday.date];
    holidayMap[holiday.date] = curr ? [...curr, holiday] : [holiday];
    if (holiday.isError) {
      errorMessage = 'Highlighted hours are not in order';
    }
  });

  return (
    <div style={styles.mainContainer}>
      <Button style={styles.button} onClick={() => onAddHolidayHour()}>Add Holiday Hours</Button>
      {
        errorMessage && (
          <Typography style={styles.errorText}>{errorMessage}</Typography>
        )
      }
      {
        Object.entries(holidayMap).map(([date, hours]) => (
            <HolidayHoursRow
              key={date}
              date={date}
              hours={hours}
              onChangeHolidayHour={onChangeHolidayHour}
              onAddHolidayHour={onAddHolidayHour}
              onDeleteHolidayHour={onDeleteHolidayHour}
            />
        ))
      }
    </div>
  );
};

export default HolidayHours;
